<template>
  <div class="blackList-box">
    <!--操作栏-->
   
    <div class="action-bar">

       <el-select v-model="params.type" size="small" clearable placeholder="请选择类型" @change="getBlackList('status')">
            <el-option v-for="item in blackType" :value="item.value" :label="item.label" :key="item.value"></el-option>
        </el-select>
      <el-input v-model="params.content" placeholder="请输入黑名单内容" size="small" clearable class="param-input"></el-input>
      <el-button type="primary" size="small" @click="search('status')">搜索</el-button>
      <el-button type="primary" size="small"  @click="addBlack('add')">+新增黑名单</el-button> 
    </div>
   
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">

      <el-table-column prop="type" label="黑名单类型" align="center" >
        <template slot-scope="scope">
          <span>{{scope.row.type || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="黑名单内容" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.content || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" >
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" align="center" fixed="right" width="250">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.blackID)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30, 50, 100]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增黑名单弹窗-->
    <add-black ref="AddBlack"  @handlerAddblack="getAddblack"></add-black>
  </div>
</template>
<script>
import { paramsFilter } from '@/utils/global'
import AddBlack from './components/addBlack'
import API from '@/api'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: '',
      total: 0,
      // 黑名单类型
     blackType: [{
        label: 'IP',
        value: 'IP'
      }],
      // 用户管理列表请求参数
      params: {
        type: '',
        content: '',
        pageNumber: 1,
        pageSize: 10
      },
    }
  },
  components: {
    AddBlack,
  },
  created() {
    this.getBlackList();
  },
  methods: {
    // 请求黑名单列表
    getBlackList(type) {
      if(type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true;
      let params = paramsFilter(this.params)
      API.getBlackList(params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

     // 新增、删除tags
    addBlack(type) {
      this.$refs.AddBlack.open(type);
    },
    // 删除黑名单
    remove(row) {
      this.$confirm('您确定要删除当前黑名单吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          API.removeBlackList({blackID: row}).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除黑名单成功',
                type: 'success'
              })
              this.getBlackList()
            } else {
              this.$message.error('删除失败')
            }
          })
        })
      .catch(() => {})
    },

    // 搜索对应列表
    search(type) {
      this.params.pageNumber = 1
      this.getBlackList(type);
    },
    // 监听新增成功回掉
    getAddblack() {
      this.getBlackList()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.pageNumber = 1
      this.getBlackList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getBlackList()
    }
  }
}
</script>
<style lang="scss">

</style>

